import { getAwsConfig } from '../aws-exports'
import { StoreInstances } from '../store/StoreInstancesContainer'
import authManager from '../api/security/Auth'

export const redirectToAllianceConnect = (
  url: string,
  dashboard?: boolean
): void => {
  const awsConfig = getAwsConfig()
  const cognitoKeyBase = `CognitoIdentityServiceProvider.${awsConfig.aws_user_pools_web_client_id}`
  const cognitoUserKeyBase = `${cognitoKeyBase}.${authManager.getUserId()}`

  const lastAuthUserValue = localStorage.getItem(
    `${cognitoKeyBase}.LastAuthUser`
  )

  const deviceKeyValue = localStorage.getItem(`${cognitoUserKeyBase}.deviceKey`)
  const accessTokenValue = localStorage.getItem(
    `${cognitoUserKeyBase}.accessToken`
  )
  const refreshTokenValue = localStorage.getItem(
    `${cognitoUserKeyBase}.refreshToken`
  )
  const idTokenValue = localStorage.getItem(`${cognitoUserKeyBase}.idToken`)

  const clockDriftValue = localStorage.getItem(
    `${cognitoUserKeyBase}.clockDrift`
  )

  const deviceGroupKeyValue = localStorage.getItem(
    `${cognitoUserKeyBase}.deviceGroupKey`
  )

  const randomPasswordKeyValue = localStorage.getItem(
    `${cognitoUserKeyBase}.randomPasswordKey`
  )

  const form = document.createElement('form')

  const orgId = document.createElement('input')
  const userId = document.createElement('input')
  const LastAuthUser = document.createElement('input')
  const clockDrift = document.createElement('input')
  const deviceGroupKey = document.createElement('input')
  const deviceKey = document.createElement('input')
  const accessToken = document.createElement('input')
  const refreshToken = document.createElement('input')
  const idToken = document.createElement('input')
  const userscreenName = document.createElement('input')
  const userLanguage = document.createElement('input')
  const randomPasswordKey = document.createElement('input')

  orgId.value = StoreInstances.userStore.preferences.wdorgId
  orgId.name = 'orgId'
  form.appendChild(orgId)

  userId.value = authManager.getUserId()
  userId.name = 'userId'
  form.appendChild(userId)

  LastAuthUser.value = lastAuthUserValue
  LastAuthUser.name = 'LastAuthUser'
  form.appendChild(LastAuthUser)

  refreshToken.value = refreshTokenValue
  refreshToken.name = 'refreshToken'
  form.appendChild(refreshToken)

  clockDrift.value = clockDriftValue
  clockDrift.name = 'clockDrift'
  form.appendChild(clockDrift)

  deviceGroupKey.value = deviceGroupKeyValue
  deviceGroupKey.name = 'deviceGroupKey'
  form.appendChild(deviceGroupKey)

  deviceKey.value = deviceKeyValue
  deviceKey.name = 'deviceKey'
  form.appendChild(deviceKey)

  accessToken.value = accessTokenValue
  accessToken.name = 'accessToken'
  form.appendChild(accessToken)

  randomPasswordKey.value = randomPasswordKeyValue
  randomPasswordKey.name = 'randomPasswordKey'
  form.appendChild(randomPasswordKey)

  idToken.value = idTokenValue
  idToken.name = 'idToken'
  form.appendChild(idToken)

  userscreenName.value = StoreInstances.userStore.preferences.screenName
  userscreenName.name = 'screenName'
  form.appendChild(userscreenName)

  userLanguage.value = StoreInstances.userStore.preferences.language
  userLanguage.name = 'userLangId'
  form.appendChild(userLanguage)

  if (dashboard) {
    const supplierDashboard = document.createElement('input')
    supplierDashboard.value = 'true'
    supplierDashboard.name = 'supplierDashboard'
    form.appendChild(supplierDashboard)
  }

  document.body.appendChild(form)
  form.hidden = true
  form.target = !dashboard ? '_parent' : '_blank'
  form.method = 'POST'
  form.action = url
  form.submit()
}
